import React from 'react'
import { t } from '../i18n'
import { useUi } from '../State/Ui'
import { shareStory } from '../Utils/share'
import { ShareIcon } from './Icons'

export default function ShareButton({ story, from = 'card', size = 20 }) {
  const { notify } = useUi()
  return (
    <button
      type="button"
      className="icon-button share-button"
      aria-label={t('card.share')}
      onClick={(e) => {
        e.stopPropagation()
        shareStory(story, notify, from)
      }}
    >
      <ShareIcon size={size} />
    </button>
  )
}
